import { render, staticRenderFns } from "./checkbox-primary-array.vue?vue&type=template&id=b30921b8&scoped=true&"
import script from "./checkbox-primary-array.vue?vue&type=script&lang=js&"
export * from "./checkbox-primary-array.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30921b8",
  null
  
)

export default component.exports